import ArticleStyle from '../../styles/relatedArticle.module.css'
import Link from 'next/link';
import { useCookies } from "react-cookie"
import { getWebsiteID } from "../../lib/common-functions"
import React, { useEffect, useState } from "react";
import { ReadMoreClick } from '../../lib/ga';
import { EventCommonObj } from '../../lib/services/helpers/eventCommonObject';
import { getReduxSession } from '../../lib/sessionHandler';
import arrow_icon_pre from '~/public/images/arrow-right-grey-inline.svg';
import arrow_icon from '~/public/images/arrow-right-grey-inline.svg';
import { useIsMobile } from '/lib/hooks/useIsMobile';
import { getWebsiteURL } from '/lib/services/helpers/getWebsiteURL';

function RelatedArticles(props) {
    const isMobileDevice = useIsMobile();
    const relatedItems = props.items.edges;
    const [storeCookie, setStoreCookie] = useCookies(["store"])
    const [prefixUrl, setPrefixUrl] = useState('')
    const [catText, setCatText] = useState('')
    const session = getReduxSession();

    const heading = props.heading;
    if (!relatedItems?.length > 0) {
        return null
    }

    useEffect(() => {
        let website_id = getWebsiteID(storeCookie);
        setPrefixUrl(getWebsiteURL(website_id))
    }, [storeCookie]);

    useEffect(() => {
        const catText1 = ((props.category) ? <a href={prefixUrl + "/blog/category/" + props.category} className={ArticleStyle["icon-see"]}>See All </a> : '');
        setCatText(catText1)
    }, [prefixUrl]);

    const eleID = Math.random().toString(36).substr(2, 9) + "_" + Date.now();

    function itemNav(nav, eleParent) {
        if (process.browser) {
            var container = document.getElementById(eleID);
            var childrens = document.getElementsByClassName('related_items')[0];

            if (nav == "next") {
                sideScroll(container, 'right', 25, 100, childrens.clientWidth);
            } else {
                sideScroll(container, 'left', 25, 100, childrens.clientWidth);
            }
        }
    }


    function sideScroll(element, direction, speed, distance, step) {
        let scrollAmount = 0;
        var slideTimer = setInterval(function () {
            if (direction == 'left') {
                element.scrollLeft -= step;
            } else {
                element.scrollLeft += step;
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    }

    const eventCommonObj = EventCommonObj(session, storeCookie)
    

    return (
        <div className={ArticleStyle["pdp-sec14"]}>
            <div className={ArticleStyle["journal-colm"]}>
                <div className={ArticleStyle["h2pdp-sec14"]}>{heading}</div>
                {catText}
            </div>
            <div className={`row ` + ArticleStyle["row"]} id={eleID}>
                {relatedItems.map(({ node }) => (
                    <div className={`col-8 related_items ` + ArticleStyle["col-8"]} key={"relatedItems" + node.id}>
                        <Link href={`${prefixUrl}/blog/${node.slug}`} key={node.id}>

                            <div className={ArticleStyle["kama-journal-box"]}>
                                {(node.featuredImage && node.featuredImage.node.mediaDetails && node.featuredImage.node.mediaDetails.file) ? <span><img loading="lazy" src={(node.featuredImage && node.featuredImage.node.mediaDetails && node.featuredImage.node.mediaDetails.file) ? process.env.WP_IMG_URL + node.featuredImage.node.mediaDetails.file : null} alt={node.title} title={node.title} width={1050} height="auto" /></span> : null}

                                <h4>{node.title}</h4>
                                 <div><div dangerouslySetInnerHTML={{ __html: (node.excerpt) }} />
                                    <a onClick={() => ReadMoreClick(node.title, node?.categories?.nodes?.[0]?.name, eventCommonObj)}>Read More</a>
                                </div>
                            </div>

                        </Link>
                    </div>
                ))}

            </div>
            <div> {!isMobileDevice && (<div className={`next_prev_btn ` + ArticleStyle["next_prev_btn"]}>
                <div className={`next_btn ` + ArticleStyle["next_btn"]}>
                    <a onClick={(e) => itemNav('prev')}><img loading="lazy" src={arrow_icon_pre.src} alt="arrow icon" width="14" height="auto" /></a></div>
                <div className={`prev_btn ` + ArticleStyle["prev_btn"]}>
                    <a onClick={(e) => itemNav('next')}><img loading="lazy" src={arrow_icon.src} alt="arrow icon" width="14" height="auto" /></a></div>

            </div>)}
            </div>
        </div>
    );

}

export default RelatedArticles;